import React from "react";
import "@fontsource/quicksand";
import "@fontsource/quicksand/600.css";
import "@fontsource/quicksand/700.css";
import "@fontsource/rubik/500.css";
import "@fontsource/rubik/600.css";
import "./assets/scss/app.scss";
import "./assets/js/custom.js";

import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import AuthApp from "./pages/App";

import Api from "./constants/Api";
import General from "./constants/General";

import AuthenticatedRoute from "./components/AuthenticatedRoute";
import NotFound from "./pages/NotFound";
import LoginPage from "./pages/Login.js";

export default class App extends React.Component {
  // componentDidMount() {
  //   window.addEventListener("unhandledrejection", (event) => {
  //     // console.error("Unhandled rejection:", event.reason);
  //     if (event.reason instanceof RangeError) {
  //       alert(
  //         "RangeError: A memory issue occurred. Please reduce the size of your input."
  //       );
  //     } else alert("Unhandled rejection: " + event.reason);
  //   });

  //   window.onerror = (message, source, lineno, colno, error) => {
  //     alert(
  //       message + "\n" + source + "\n" + lineno + "\n" + colno + "\n" + error
  //     );
  //   };

  //   window.onunhandledrejection = (event) => {
  //     // console.error("Unhandled promise rejection:", event.reason);
  //     alert("Unhandled promise rejection: " + event.reason);
  //   };

  //   // if (!document.getElementById("root").innerHTML) {
  //   //   alert("The app encountered a critical error. Reloading...");
  //   //   // location.reload();
  //   // }
  // }

  render() {
    return (
      // <ErrorBoundary>
      <BrowserRouter>
        <Switch>
          <Route exact path="/404" component={NotFound} />
          <Route exact path="/login" component={LoginPage} />

          <AuthenticatedRoute exact path="/" component={AuthApp} />
          <Redirect to="/404" />
        </Switch>
      </BrowserRouter>
      // </ErrorBoundary>
    );
  }
}
